import styled from '@emotion/styled';

export const HomePage = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Content = styled.div`
  display: flex;
  max-width: 500px;
  text-align: justify;
  letter-spacing: 1px;
`;
